<div class="report-adjustments-period-component" fxLayout="column">
    <app-available-dates-selector
        [typeSelect]="'period'"
        [scenarios]="scenarios"
        [scenario]="options.scenario"
        [startDate]="options.startDate"
        [endDate]="options.endDate"
        [availableDates]="periodAvailable()"
        [periodName]="options.period"
        [disabledStartDate]="options?.comparation?.active"
        [disabledScenario]="!!options?.budget || !!options?.projection"
        [configs]="dropdownConfigs"
        (handleApply)="onApplyPeriod($event)"
        (handleSelectScenario)="onSelectScenarioPeriod($event)"
    ></app-available-dates-selector>
</div>
